export const LogoMark = ({ size = 40, className = "", cyan = "#4FC3E8" }) => (
  <svg viewBox="0 0 64 64" width={size} height={size} fill="none" className={className} aria-hidden="true">
    <circle
      cx="32"
      cy="32"
      r="26"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeDasharray="136 28"
      transform="rotate(-30 32 32)"
    />
    <path d="M14 44 L24 20 L32 36" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M32 36 L46 8 L50 44" stroke={cyan} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ dark = false, size = 36, testId = "logo-malansh" }) => (
  <div data-testid={testId} className="flex items-center gap-3 select-none">
    <LogoMark size={size} className={dark ? "text-white" : "text-brand-indigo"} />
    <div className="leading-none">
      <div className={`font-display text-[15px] font-bold tracking-[0.2em] ${dark ? "text-white" : "text-brand-indigo"}`}>MALANSH</div>
      <div className="mt-1 font-mono text-[9px] uppercase tracking-[0.32em] text-brand-cyan">Solutions Pvt. Ltd.</div>
    </div>
  </div>
);
